import type {IconButtonProps as ChakraIconButtonProps} from '@chakra-ui/react';
import {forwardRef, IconButton as BaseButton} from '@chakra-ui/react';
import merge from 'lodash/merge';
import type {ReactElement} from 'react';

import {useIconButtonStyleConfig} from '../../theme-config';

export type IconButtonProps = {icon: ReactElement<any>} & Omit<ChakraIconButtonProps, 'rightIcon' | 'leftIcon'>;

export const IconButton = forwardRef<IconButtonProps, 'button'>((props, ref) => {
  const sx = useIconButtonStyleConfig(props);
  // User can override sx prop
  const mergedProps = merge({}, {sx}, props);
  return <BaseButton variant={props.variant} data-variant={props.variant} ref={ref} {...mergedProps} />;
});
